// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".screens-rotation[data-v-fd02db18] {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  gap: 16px;\n  color: #6a6b6a;\n  font-weight: 500;\n}\n.screens-rotation .screen[data-v-fd02db18] {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
